import type { ConversationListItemResponse } from "@redotech/effect-api-shared/models/shopper-ai/conversation/conversation";
import DotsVerticalIcon from "@redotech/redo-icons/dots-vertical.svg";
import {
  DropdownMenu,
  DropdownMenuTrigger,
} from "@redotech/redo-web/components/ui/dropdown-menu";
import { memo, useCallback } from "react";
import { ConversationActionsDropdown } from "../../../actions/conversation-actions-dropdown";
import { useConversationsTableContext } from "../../conversations-table-context";

interface ConversationActionsMenuProps {
  conversation: ConversationListItemResponse;
}

export const ConversationActionsMenu = memo(function ConversationActionsMenu({
  conversation,
}: ConversationActionsMenuProps) {
  const { actionMenuOpenForId, setActionMenuOpenForId } =
    useConversationsTableContext();

  const isOpen = actionMenuOpenForId === conversation.id;
  const setIsOpen = useCallback(
    (open: boolean) => setActionMenuOpenForId(open ? conversation.id : null),
    [setActionMenuOpenForId, conversation.id],
  );

  const handleClose = useCallback(() => setIsOpen(false), [setIsOpen]);

  return (
    <DropdownMenu onOpenChange={setIsOpen} open={isOpen}>
      <DropdownMenuTrigger
        className="flex h-8 w-8 items-center justify-center rounded hover:bg-gray-100"
        onClick={(e) => e.stopPropagation()}
      >
        <DotsVerticalIcon className="h-4 w-4" />
      </DropdownMenuTrigger>
      <ConversationActionsDropdown
        conversation={conversation}
        conversationId={conversation.id}
        isOpen={isOpen}
        onClose={handleClose}
      />
    </DropdownMenu>
  );
});
